import { render } from "./SortableColumn.vue?vue&type=template&id=4c6749d0&ts=true"
import script from "./SortableColumn.vue?vue&type=script&lang=ts"
export * from "./SortableColumn.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__